import { Form,Input  } from 'antd-mobile';
import { getRules } from './util';
const InputNumberForm = (props) => {
    let { updated, desc } = props;
    const disabled = updated !== 0;
    //最大值和最小值在外层form.item判断了
    let { setting = {} } = props,
     { number_range } = setting,
     [min, max] = number_range;
    return (
        <>
            <Form.Item label={props.label === undefined ? props.name : props.label} name={props.en_name} 
                rules={getRules(props)}
                layout={'horizontal'}
                childElementPosition={'right'}
                getValueFromEvent={(value) => {
                    if(value && Number(value) > max) {
                        return max;
                    }
                    if(value && Number(value) < min) {
                        return min;
                    }
                    if(/\D/g.test(value)){
                        return value.replace(/\D/g,'');
                    }
                    return value;
                }}
            >
                <Input disabled={disabled} style={{ width: '100%','--text-align': 'right' }} placeholder={desc || '请输入'}></Input>
            </Form.Item>
        </>
    );
};
export default InputNumberForm;
